import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { pageSchemas } from "@/lib/seo/page-schema";
import { RetailIndustryPageBG } from "@/components/site/RetailIndustryPageBG";
import { RETAIL_META_DESCRIPTION_BG } from "@/content/meta/RetailIndustryPageBG";

export const Route = createFileRoute("/bg/industries/retail")({
  head: () => ({
    meta: [
      { title: "Медиен мониторинг и анализи за ритейл | Perceptica" },
      {
        name: "description",
        content: RETAIL_META_DESCRIPTION_BG,
      },

      { property: "og:title", content: "Медиен мониторинг и анализи за ритейл | Perceptica" },
      { property: "og:description", content: RETAIL_META_DESCRIPTION_BG },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Медиен мониторинг и анализи за ритейл | Perceptica" },
      { name: "twitter:description", content: RETAIL_META_DESCRIPTION_BG },
      { property: "og:url", content: "https://perceptica.com/bg/industries/retail" },
      ...ogImageMeta("bg", "/industries/retail"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/industries/retail" }),
  }),
  component: RetailIndustryPageBG,
});
